import type { FaireProductEntity } from "../../entity_types/product";

export const p_cmfk2t3qjv: FaireProductEntity = {
  token: "p_cmfk2t3qjv",
  type: "product",
  name: "925 diamond eternity band",
  brandToken: "b_pnfabwsu5v",
  brandName: "Glam Bar Bazaar",
  imageUrl:
    "https://cdn.faire.com/fastly/21115e853f2b6b3625e21413b81bba63477fd6612093c4674c139be7efc4e5de.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2080ec92fa6507e355721536adfeb65f1d30a1db123e43a02448154bdc3efb0f.jpeg",
  ],
  priceDollars: 47.4,
  description:
    "Material: 925 Sterling silver plated 18k gold\n\nAAAAA Cubic zirconia crystals\n",
  tags: [],
  msrpDollars: 79,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:38.084Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
